// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PolicyCheckFields-module-container-1MLjW{display:grid;grid-gap:24px;gap:24px}.PolicyCheckFields-module-isPolicyRead-y74YG,.PolicyCheckFields-module-isAdult-24ovG{font-weight:var(--weight-light);letter-spacing:0;line-height:23px;color:#5b615e}.PolicyCheckFields-module-isPolicyRead-y74YG div,.PolicyCheckFields-module-isAdult-24ovG div{font-size:16px}.PolicyCheckFields-module-isPolicyReadLink-1AccD a{text-decoration:none;font-weight:var(--weight-medium)}", ""]);
// Exports
exports.locals = {
	"container": "PolicyCheckFields-module-container-1MLjW",
	"isPolicyRead": "PolicyCheckFields-module-isPolicyRead-y74YG",
	"isAdult": "PolicyCheckFields-module-isAdult-24ovG",
	"isPolicyReadLink": "PolicyCheckFields-module-isPolicyReadLink-1AccD"
};
module.exports = exports;
